import React from 'react'
import stores from '../stores'

//debug purposes
window.__stores = stores

export const storesContext = React.createContext(stores)